import ReactModal from "react-modal";
import "../../../components/modal/ModalCss.scss";
import BasicButton from "components/button/BasicButton";
import { sendPost } from "api/restUtil";
import { useEffect, useState } from "react";
import CommonCodeSelect from "components/input/CommonCodeSelect";
import { checkAndRemoveInvalid, checkRequiredAndInvalid, makeRequireColumns } from "js/requireCheck";
import { getResultMsg } from "js/order";

/**
 * 반품 요청 팝업
 */
function OrderReturnReqModal (props) {

	const { isOpen, onClose, modalId, initData } = props;
	const [data, setData] = useState({});	// 취소 요청 정보

	const popupDivId = "orderReturnReqPopup";

	useEffect(() => {
		if(isOpen && initData) {
			setData({...initData});
		};

	}, [isOpen, initData])

	// 정보 변경
	const handleDataChange = (e) => {
		const {name, value} = e.target;

		setData(prev => ({...prev, [name]: value}));
	}

	// 반품 요청 처리
	const productOrderReturnRequest = async () => {
		const preSelector = "#" + popupDivId;
		const requiredColumns = ["returnReason", "collectDeliveryMethod"];
		if(!checkRequiredAndInvalid(makeRequireColumns(requiredColumns), data, preSelector)) return;

		const param = {...data};

		if(!window.confirm("반품 요청 하시겠습니까?")) return;

		const result = await sendPost("/api/order/claim/return/req", param);
		if(result.respCode === "SUCCESS") {
			if(result.data.data.successProductOrderIds.length > 0) {
				alert("반품 요청 되었습니다.");
			} else {
				const msg = getResultMsg(result.data.data);
				alert(msg);
			}
			
			onClose(result.data.data.successProductOrderIds.length, result.data.data.failProductOrderInfos.length);
		}
	}
	
	// 데이터 변경 시 invalid 제거 처리
	useEffect(() => {
		checkAndRemoveInvalid(data, "#" + popupDivId);
	}, [data]);


	return (
		<ReactModal
			appElement={document.getElementById("root")}
			isOpen={isOpen}
			// onRequestClose={onClose}
			contentLabel={"상품주문 반품 요청 팝업"}
			id={modalId}
		>
			<div className="me-modal" id={popupDivId}>
				<div className="me-modal-container" style={{width: "500px", height: "450px"}}>
					<div className="me-modal-inner">
						<div className="me-modal-header handle-area">
							<h4 className="header-title">상품주문 반품 요청</h4>
						</div>
						<div className="me-modal-body" style={{overflowY: "auto", overflowX: "hidden"}} >	{/* 달력때문에 overflow visible설정 */}
							<div className="grid-table" style={{gridTemplateColumns: "1fr 3fr"}}>
								
								<div className="th required">반품 사유</div>
								<div className="td">
									<CommonCodeSelect
										item={{col: "returnReason"}} 
										onChange={handleDataChange} 
										value={data?.returnReason || ""} 
										defaultLabel="선택" 
										grpCd="RETURN_REASON" 
									/>
								</div>

								<div className="th required">반품 배송 방법</div>
								<div className="td">
									<CommonCodeSelect
										item={{col: "collectDeliveryMethod"}} 
										onChange={handleDataChange} 
										value={data?.collectDeliveryMethod || ""} 
										defaultLabel="선택" 
										grpCd="DELIVERY_METHOD" 
									/>
								</div>

								{/* <div className="th">택배사 코드</div>
								<div className="td">
									<CommonCodeSelect
										item={{col: "collectDeliveryCompany"}} 
										onChange={handleDataChange} 
										value={data?.collectDeliveryCompany || ""} 
										defaultLabel="선택" 
										grpCd="DELIVERY_COMPANY_CODE" 
									/>
								</div>

								<div className="th">수거 송장 번호</div>
								<div className="td">
									<BasicInput item={{col: "collectTrackingNumber"}} value={data?.collectTrackingNumber} onChange={handleDataChange} width="" textAlign="left" />
								</div> */}

								{/* <div className="th">반품 수량</div>
								<div className="td">
									<Float className="basic-input" name={"returnQuantity"} value={data?.returnQuantity ?? ""} decimalPlaceCnt={0} onChange={handleDataChange} style={{width: "250px", textAlign: "left"}} addComma={true} minVal={1} />
								</div> */}
							</div>
						</div>
						<div className="me-modal-footer mg-b-20" style={{marginTop: "auto"}}>
							<div className="table-buttons" style={{justifyContent : "center"}}>
								<BasicButton label="취소" className="btn-cancel" onClick={() => onClose(null)} style={{width: "100%"}} />
								<BasicButton label="확인" className="btn-save" onClick={() => productOrderReturnRequest()} style={{width: "100%"}} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</ReactModal>
	);
}

export default OrderReturnReqModal;
